import { useEffect } from 'react';
import { graphql } from 'gatsby';

export const useDataLayer = data => {
  useEffect(() => {
    resetDeferredDataLayer();

    window.dataLayer = window.dataLayer || [];

    if (window.dataLayer && data) {
      if (data.pageData) {
        window.dataLayer.push(data.pageData);
      }

      if (data.product) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          ecommerce: {
            detail: {
              products: [data.product],
            },
          },
        });
      }

      if (data.checkout) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'checkout',
          ecommerce: {
            checkout: {
              actionField: {
                step: data.checkout.step,
                option: data.checkout.option,
              },
            },
          },
        });
      }
    }
  }, [data]);
};

export const resetDeferredDataLayer = () => {
  if (window.deferredDataLayer) {
    window.deferredDataLayer.consentResolved = false;
  }
};

export const onClickDataLayer = (data, product, requiredConsent) => {
  window.dataLayer = window.dataLayer || [];
  window.deferredDataLayer = window.deferredDataLayer || {
    updateDataLayer: grantedConsent => {
      if (
        window.deferredDataLayer[grantedConsent] &&
        window.deferredDataLayer[grantedConsent].length
      ) {
        const dataLayerUpdate = [...window.deferredDataLayer[grantedConsent]];
        window.deferredDataLayer[grantedConsent] = [];

        for (let i = 0; i < dataLayerUpdate.length; i++) {
          window.dataLayer.push(dataLayerUpdate[i]);
        }
      }
      window.deferredDataLayer.consentResolved = true;
    },
    consentResolved: false,
  };

  let dataLayer = window.dataLayer;
  if (requiredConsent) {
    if (!window.deferredDataLayer[requiredConsent]) {
      window.deferredDataLayer[requiredConsent] = [];
    }
    if (!window.deferredDataLayer.consentResolved) {
      dataLayer = window.deferredDataLayer[requiredConsent];
    }
  }

  if (dataLayer && data) {
    if (data.checkout) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: {
              step: data.checkout.step,
              option: data.checkout.option,
            },
            products: product,
          },
        },
      });
    } else if (data.addToCart) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          add: {
            products: product,
          },
        },
      });
    } else if (data.purchase) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'purchase',
        ecommerce: {
          purchase: {
            actionField: {
              id: data.purchase.id,
              affiliation: data.purchase.affiliation,
              revenue: data.purchase.revenue,
              tax: data.purchase.tax,
              shipping: data.purchase.shipping,
            },
            products: product,
          },
        },
      });

      // Notify Adobe after the purchase data is available.
      if (typeof window._satellite?.track === 'function') {
        window._satellite.track('purchase');
      }
    } else if (data.customData) {
      dataLayer.push({ ...data.customData });
    }
  }
};

export const DataLayerFragment = graphql`
  fragment DataLayerFragment on SPASEEKERS_GTMDataLayer {
    pageData {
      carParking
      country
      county
      disabledAccess
      guestRating
      hotelRating
      package
      packageCategory
      packageType
      pageType
      region
      spaGroup
      spaName
      town
      wifi
    }
    product {
      brand
      category
      id
      list
      name
      price
    }
  }
`;
